import React from 'react';

import { LabelledText } from 'modules/layer00';
import { BaseWidget } from 'modules/layer01';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
  variant?: 'customer' | 'partner';
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.returnAuthorizationId, props.variant === 'customer');

  return (
    <BaseWidget.FC title="Return Information">
      <LabelledText.FC
        title="Order Number"
        text={tuple.data.orderNumber} />

      <LabelledText.FC
        title="Return Number"
        text={tuple.data.returnNumber} />

      <LabelledText.FC
        title="Order Source"
        text={tuple.data.storeTypeDisplayName} />
    </BaseWidget.FC>
  );
};
